<template>
    <kiosk-user-details :userId="props.userId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <page-header>Logins</page-header>

            <page-loading v-if="loading && !list.length"></page-loading>

            <div v-else-if="list.length">
                <vx-table class="xl:grid-cols-4 mb-8" rowBreakpoint="xl">
                    <vx-table-row isHeader>
                        <div class="lg:pl-6">Time</div>
                        <div>Result</div>
                        <div>IP Address</div>
                        <div>User Agent</div>
                    </vx-table-row>

                    <vx-table-row v-for="login in list" :key="login.id" data-test="login">
                        <vx-table-row-title>
                            {{ shortDateTime(login.created_at) }}
                        </vx-table-row-title>

                        <vx-table-row-item>
                            <template v-slot:label> Result: </template>
                            {{ 'success' === login.result ? 'Success' : 'Failed' }}
                        </vx-table-row-item>

                        <vx-table-row-item>
                            <template v-slot:label> IP Address: </template>
                            {{ login.ip_address || '-' }}
                        </vx-table-row-item>

                        <vx-table-row-item>
                            <template v-slot:label> User Agent: </template>
                            <vx-popover hover arrow placement="top" class="[&>div:first-child]:truncate w-full">
                                {{ login.user_agent || '-' }}
                                <template v-if="login.user_agent" v-slot:content>
                                    <div class="max-w-xs break-all">{{ login.user_agent }}</div>
                                </template>
                            </vx-popover>
                        </vx-table-row-item>
                    </vx-table-row>
                </vx-table>

                <div class="mt-8 flex justify-between w-full gap-10">
                    <vx-button
                        v-if="fetchParams.cursor"
                        @click="loadData()"
                        color="muted-dark"
                        size="xl"
                        class="grow-0"
                        data-test="load-more-btn"
                        :loading="loading"
                    >
                        Load More
                        <font-awesome-icon widthAuto :icon="faSpinner"></font-awesome-icon>
                    </vx-button>
                </div>
            </div>

            <empty-state v-else> No logins yet. </empty-state>
        </div>
    </kiosk-user-details>
</template>

<script setup>
import KioskUserDetails from './KioskUserDetails.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import EmptyState from '~/components/general/EmptyState.vue';
import { adminUsersClient } from '~/services/index';
import { useCursorPagination } from '~/composables/useCursorPagination';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxPopover, VxTable, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import { shortDateTime } from '~/utils/date';

const props = defineProps({
    userId: {
        type: Number,
        required: true,
    },
});

const { loading, list, fetchParams, fetchRecords } = useCursorPagination();

const loadData = () => {
    fetchRecords(adminUsersClient.listUserLogins(props.userId, fetchParams.value));
};

fetchParams.value = { cursor: null };
loadData();
</script>
